import { useNavigate, useParams } from "react-router-dom"
import { Button } from "@/components/ui/button"
import CustomerTable from "@/components/CustomerTable"
import useCurrentUser from "@/hooks/use-current-user"
import { useAuth } from "@/hooks/useAuth"
import { hasPermission } from "@/lib/admin-permissions"

export default function CustomersPage() {
  const navigate = useNavigate()
  const { councilId } = useParams()
  const { user } = useAuth()
  const { councils, hasRole } = useCurrentUser()
  const scopedCouncilId = councilId ? Number(councilId) : undefined
  const canWriteCustomers =
    hasRole("super_admin") ||
    hasPermission(user?.permissions, "customers", "write_own", scopedCouncilId) ||
    hasPermission(user?.permissions, "customers", "write_all", scopedCouncilId)
  const currentCouncil = councils?.find((c) => String(c.id) === councilId)
  return (
    <div className="flex h-[calc(100vh-7rem)] flex-col space-y-6 overflow-hidden">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">Customers</h1>
          <p className="text-muted-foreground">
            All customers in {currentCouncil?.name} with device and billing information
          </p>
        </div>
        {canWriteCustomers && (
          <div className="flex justify-end gap-x-2">
            <Button
              size="sm"
              variant="default"
              onClick={() => navigate(`${councilId ? `/council/${councilId}/add-customer` : ""}`)}
            >
              Add Customer
            </Button>
          </div>
        )}
      </div>

      <CustomerTable />
    </div>
  )
}
